import { render, staticRenderFns } from "./ArrowSvg.vue?vue&type=template&id=498ed62b&"
import script from "./ArrowSvg.vue?vue&type=script&lang=js&"
export * from "./ArrowSvg.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports